$(document).ready(function () {


    //stick in the fixed 100% height behind the navbar but don't wrap it
    $('#slide-nav.navbar .container').append($('<div id="navbar-height-col"></div>'));

    // Enter your ids or classes
    var toggler = '.navbar-toggle';
    var pagewrapper = '#page-content';
    var navigationwrapper = '.navbar-header';
    var menuwidth = '100%'; // the menu inside the slide menu itself
    var slidewidth = '80%';
    var menuneg = '-100%';
    var slideneg = '-80%';


    $("#slide-nav").on("click", toggler, function (e) {

        var selected = $(this).hasClass('slide-active');

        $('#slidemenu').stop().animate({
            left: selected ? menuneg : '0px'
        });

        $('#navbar-height-col').stop().animate({
            left: selected ? slideneg : '0px'
        });

        $(pagewrapper).stop().animate({
            left: selected ? '0px' : slidewidth
        });

        $(navigationwrapper).stop().animate({
            left: selected ? '0px' : slidewidth
        });


        $(this).toggleClass('slide-active', !selected);
        $('#slidemenu').toggleClass('slide-active');


        $('#page-content, .navbar, body, .navbar-header').toggleClass('slide-active');


    });


    var selected = '#slidemenu, #page-content, body, .navbar, .navbar-header';


    $(window).on("resize", function () {

        if ($(window).width() > 767 && $('.navbar-toggle').is(':hidden')) {
            $(selected).removeClass('slide-active');
        }


    });





// navigation

$(".navbar-toggle").on("click", function () {
    $(this).toggleClass("active");
});

// $( ".cat-item").on("click", function() {
//     $(this).toggleClass('active').siblings().removeClass('active');
// });
//
// $( ".subcat-item").on("click", function() {
//     $(this).toggleClass('active').siblings().removeClass('active');
// });
//
// $(".meganav-cat-item a").on("click", function () {
//     $(this).toggleClass("active").siblings().removeClass('active');
// });
//
// $( ".nav-item").on("click", function() {
//     $(this).toggleClass('active').siblings().removeClass('active');
// });
//
// $('#navCat-1').on('click', function(){
//     $('#navCatContent-1').toggleClass("active").fadeToggle('fast');
// });
//
// $('#navItem-1').on('click', function(){
//     $('#navContent-1').toggleClass("active").fadeToggle('fast');
// });
//
// $('#cat-item-1').on('click', function(){
//     $('#subCatContent-tere-2').toggleClass("active").fadeToggle('fast');
// });
//
// $('#subcat-item-1').on('click', function(){
//     $('#featureAd-1').toggleClass("active").fadeToggle('fast');
// });


// $('.nav-item').on('click', function(event){
// var currentIndex = $(this).index();
// console.log(currentIndex);
// if ( $(this).hasClass('active') ){
//  $(this).removeClass('active');
//  $('.mega-nav-item').removeClass('active');
// } else {
//  $(this).addClass('active').siblings().removeClass('active');
//  $('.mega-nav-item').each(function(index, element){
//    if ( index == currentIndex ){
//      $(this).addClass('active');
//    } else{
//      $(this).removeClass('active');
//    }
//  });
// }
// });


$('.nav-item').on('click', function(event){
 var currentIndex = $(this).index();
 if ( $(this).hasClass('active') ){
   $(this).removeClass('active');
   $('.mega-nav-item.active').removeClass('active');
 } else{
   $(this).addClass('active').siblings().removeClass('active');
   $('.mega-nav-item').each(function(index, element){
     if ( index == currentIndex ){
       $(this).addClass('active').siblings().removeClass('active');
     }
   });
 }
});

$(".mega-sub-item").on("click", function(event){
  var subItemCurrentIndex = $(this).index();
  console.log(subItemCurrentIndex);
  if ( $(this).hasClass('active') ){
    $(this).removeClass('active');
    $('.mega-catnav-item').removeClass('active');
  } else{
    $(this).addClass('active').siblings().removeClass('active');
    $('.mega-catnav-item').each(function(index, element){
      if ( index == subItemCurrentIndex ){
        $(this).addClass('active').siblings().removeClass('active');
        // $('.intro').addClass('active');


      }
    });
    }
});

$(".cat-item").on("click", function(event){
  var catItemCurrentIndex = $(this).index();
  console.log(catItemCurrentIndex);
  if ( $(this).hasClass('active') ){
    $(this).removeClass('active');
    // $('.intro.active').removeClass('active');
    $('.mega-catnav-item-unstyled').toggleClass('active');
  } else{
    $(this).addClass('active').siblings().removeClass('active');
    $('.mega-catnav-item-unstyled').each(function(index, element){
      if ( index == catItemCurrentIndex ){
        $(this).addClass('active');
      }
    });
    }
});

$(".subcat-item").on("click", function(event){
  var subcatItemCurrentIndex = $(this).index();
  console.log(subcatItemCurrentIndex);
  if ( $(this).hasClass('active') ){
    $(this).removeClass('active');
    $('.meganav-link-custom').toggleClass('active');
  } else{
    $(this).addClass('active').siblings().removeClass('active');
    $('.meganav-link-custom').each(function(index, element){
      if ( index == subcatItemCurrentIndex ){
        $(this).addClass('active').children().removeClass('active');;
      }
    });
    }
});

});
